import logoHelpScout from 'components/images/logos/logo_helpscout.svg'
import useHelpScoutSetup from './useHelpScoutSetup'
import ChannelCard from "../../Utilities/ChannelCard";

export default function HelpScoutProvider() {
	const { initiateHelpScoutSetup } = useHelpScoutSetup({ callbackPath: '/helpscout/accounts' })
	return (
		<ChannelCard
			icon={logoHelpScout}
			label={'HelpScout'}
			description={'Resolve support tickets and clear your backlog'}
			onClick={initiateHelpScoutSetup}
		/>
	)
}